package com.cybersoftsolution.cybersoftsolutionweb.components.navigation

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.VectorIcon
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.selectedColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.cybersoftsolution.cybersoftsolutionweb.styles.NavigationItemStyleCss
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun NavigationItem(
    modifier: Modifier = Modifier.fillMaxWidth(),
    selected: Boolean = false,
    title: String,
    icon: String,
    onClick: () -> Unit,
){

    Row(
        modifier = NavigationItemStyleCss.toModifier()
            .then(modifier)
            .cursor(Cursor.Pointer)
            .margin(bottom = 20.px)
            .onClick { onClick() },
        verticalAlignment = Alignment.CenterVertically

    ){



        VectorIcon(
            modifier = NavigationItemStyleCss.toModifier()
                .margin(right = 10.px)
                .id(IdConst.navigationIcon),
            pathData = icon,
            color = if (selected) {
                selectedColor
            } else {
                unselectedColor
            },
            size = 48
        )


        SpanText(
            text = title,
            modifier = NavigationItemStyleCss.toModifier()
                .id(IdConst.navigationText+selected.toString())
                .fontSize(16.px)
                .fillMaxWidth()
        )


    }

}